import { render, staticRenderFns } from "./DetailRecord.vue?vue&type=template&id=61d3d9ea&scoped=true&"
import script from "./DetailRecord.vue?vue&type=script&lang=ts&"
export * from "./DetailRecord.vue?vue&type=script&lang=ts&"
import style0 from "./DetailRecord.vue?vue&type=style&index=0&id=61d3d9ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3d9ea",
  null
  
)

export default component.exports